export class BillingInstructions {
  shipperBillingInstructions = 'NA';
  consigneeBillingInstructions = 'NA';
  billToBillingInstructions = 'NA';

  constructor() { }
}
